import { getModuleGroupById, registerApplication } from '@softline/application';
import { default as de } from '../i18n/de.json';
import {
  SOFTLINE_CONFIG_WORKFLOW_TYPE,
  WorkflowTypeConfig,
} from '@softapps/gewerbe/workflow';
import { StockPostingRepository } from './repository/stock-posting.repository';

export const einseitigeLagerbuchungProviders = [
  registerApplication({
    name: 'Lagerbuchung',
    icon: 'fa-regular fa-boxes-packing',
    title: 'Einseitige Lagerbuchung',
    route: '/mde-stockposting/erfassung',
    permission: 'SOFTAPPS.MDE.STOCKPOSTING.ACCESS',
    group: getModuleGroupById(6),
    translations: {
      de,
    },
  }),
  {
    provide: SOFTLINE_CONFIG_WORKFLOW_TYPE,
    useValue: {
      type: 'STOCKPOSTING',
      getRoute: (workflow) => ['/mde-stockposting/workflow', String(workflow.id)],
      getSummary: () =>
        import('./pages/stock-posting-workflow/stock-posting-workflow.summary').then(
          (m) => m.getStockPostingWorkflowSummary
        ),
      getSummaryProviders: () => [StockPostingRepository],
      viewModes: ['table', 'kanban'],
    } satisfies WorkflowTypeConfig,
    multi: true,
  },
];
